export const calculateSpacing = () => {
  //
}

export const chartTheme = {
  fontFamily: 'Effra, sans-serif',
  textColor: '#4E516B',
  fontSize: 10,
  lineHeight: 11,
  fontWeight: 500,
}

export const truncateDevelopmentScoresLabel = (text: string, limit = 30) => {
  try {
    if (text.length <= limit) {
      return text
    }
    return `${text.substring(0, limit)}...`
  } catch {
    return text
  }
}
